export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy'
export const DATE_OF_YEAR_FORMAT = 'do of MMMM, yyyy'
export const DATE_OF_MONTH_FORMAT = 'MMM do'
